




























import { bemBuilder } from "@chatfood/core-utils";
import { defineComponent, computed } from "@vue/composition-api";

const css = bemBuilder("atom-radio");

export default defineComponent({
  name: "AtomCheckbox",
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    rightContent: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  setup(props, { slots, emit }) {
    const hasContent = computed(() => Boolean(slots.default));

    function handleChange() {
      if (props.disabled || props.checked) return;

      emit("change", props.value);
    }

    return {
      css,
      hasContent,
      handleChange,
    };
  },
});
